import type { ReactNode } from 'react';
import { TextEllipsis } from '../TextEllipsis/TextEllipsis.js';

interface BadgeCopyProps {
  children: ReactNode;
}

const BadgeCopy = ({ children }: BadgeCopyProps) => {
  return (
    <TextEllipsis asChild>
      <span>{children}</span>
    </TextEllipsis>
  );
};

export { BadgeCopy };
